/**
 * RESPONSIBILITY: say whether a link goes to a map.
 *
 * A map opens in a new tab, everywhere on the site: somebody checking where the church is
 * has not finished reading the page they are on, and on a phone the maps app takes over
 * the screen — they should come back to where they were. ONE answer for "is this a map"
 * (rule 12): the components that draw a location button ask it, and so does the
 * site-wide listener that catches map links typed into text — see useMapLinksInNewTab.
 */
const MAP_HOSTS = /(^|\.)((maps\.app\.goo\.gl)|(maps\.google\.[a-z.]+)|(maps\.apple\.com)|(waze\.com))$/i;
const MAP_PATHS = /^(www\.)?(google\.[a-z.]+\/maps|goo\.gl\/maps|bing\.com\/maps)/i;

export function isMapLink(href: string | undefined): boolean {
  if (!href) return false;
  try {
    const u = new URL(href, window.location.href);
    if (u.origin === window.location.origin) return false;
    return MAP_HOSTS.test(u.hostname) || MAP_PATHS.test(u.hostname + u.pathname);
  } catch {
    return false;
  }
}

/** Spread onto an <a>: a map opens in a new tab, anything else is left alone. */
export const mapTarget = (href: string | undefined) =>
  (isMapLink(href) ? { target: '_blank', rel: 'noopener noreferrer' } : {});
